var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAuthenticator = function SvgAuthenticator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 10.498c0 .638-.396 1.182-.956 1.4l.456 4.105h-2l.456-4.105a1.502 1.502 0 0 1 .544-2.9 1.5 1.5 0 0 1 1.5 1.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 7.164 11.5 4 4 7.164v3.447c0 4.646 2.918 8.79 7.289 10.352a.628.628 0 0 0 .422 0A10.992 10.992 0 0 0 19 10.611V7.164ZM5 10.61V7.828l6.5-2.742L18 7.828v2.783a9.992 9.992 0 0 1-6.5 9.364A9.992 9.992 0 0 1 5 10.611Z",
    fill: "currentColor"
  })));
};
export default SvgAuthenticator;